import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';

interface Props {}

const ArticleBoxCubeLoader: FC<Props> = () => {
	return (
		<ContentLoader height={600} width={600} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
			<rect x="2" y="3" rx="4" ry="4" width="436" height="242" />
			<rect x="329" y="23" rx="0" ry="0" width="88" height="12" />
			<rect x="-1" y="275" rx="0" ry="0" width="78" height="10" />
			<rect x="-32" y="304" rx="0" ry="0" width="289" height="17" />
			<rect x="1" y="331" rx="0" ry="0" width="210" height="21" />
			<rect x="3" y="385" rx="0" ry="0" width="298" height="18" />
			<rect x="4" y="414" rx="0" ry="0" width="368" height="20" />
			<rect x="1" y="443" rx="0" ry="0" width="339" height="22" />
		</ContentLoader>
	);
};

export default ArticleBoxCubeLoader;
